import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import styles from './enterprise_header_infos.module.scss';
import { EnterpriseContext } from '../EnterpriseContext';

export const EnterpriseHeaderInfos: FC = () => {
  const {
    enterpriseInfos: {
      adresse,
      raisonSociale,
      appellationCommerciale,
      enseigne,
      cleanSiren,
      nic,
      siren,
      secteurActivite,
      dateCreation,
      tailleGlob,
      formeJuridique,
    },
  } = useContext(EnterpriseContext);
  const mapLink = `https://www.google.com/maps/search/?api=1&query=
  ${encodeURIComponent(adresse)}`;

  return (
    <div className={styles.container}>
      {raisonSociale && (
        <InfosItem
          labelId="app.pages.enterprise.header.infos.companyName"
          value={raisonSociale}
        />
      )}
      {appellationCommerciale && (
        <InfosItem
          labelId="app.pages.enterprise.header.infos.tradeName"
          value={appellationCommerciale}
        />
      )}
      {enseigne && (
        <InfosItem
          labelId="app.pages.enterprise.header.infos.sign"
          value={enseigne}
        />
      )}
      {adresse && (
        <div className={styles.item}>
          <span className={styles.label}>
            <FormattedMessage id="app.pages.enterprise.header.infos.address" />
          </span>
          <Hyperlink className={styles.link} href={mapLink}>
            {adresse}
          </Hyperlink>
        </div>
      )}
      {cleanSiren && (
        <InfosItem
          labelId="app.pages.enterprise.header.infos.siren"
          value={cleanSiren}
        />
      )}
      {nic && (
        <InfosItem
          labelId="app.pages.enterprise.header.infos.siret"
          value={`${siren}${nic}`}
        />
      )}
      {secteurActivite && (
        <InfosItem
          labelId="app.pages.enterprise.header.infos.sector"
          value={secteurActivite}
        />
      )}
      {formeJuridique && (
        <InfosItem
          labelId="app.pages.enterprise.header.infos.form"
          value={formeJuridique}
        />
      )}
      {dateCreation && (
        <InfosItem
          labelId="app.pages.enterprise.header.infos.start"
          value={dateCreation}
        />
      )}
      {tailleGlob && (
        <InfosItem
          labelId="app.pages.enterprise.header.infos.size"
          value={tailleGlob}
        />
      )}
    </div>
  );
};

const InfosItem: FC<{
  labelId: string;
  value: string;
}> = ({ labelId, value }) => (
  <div className={styles.item}>
    <span className={styles.label}>
      <FormattedMessage id={labelId} />
    </span>
    <span className={styles.value}>{value}</span>
  </div>
);
